import { render, staticRenderFns } from "./Buzzer.vue?vue&type=template&id=d31e7f62&scoped=true"
import script from "./Buzzer.vue?vue&type=script&lang=js"
export * from "./Buzzer.vue?vue&type=script&lang=js"
import style0 from "./Buzzer.vue?vue&type=style&index=0&id=d31e7f62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31e7f62",
  null
  
)

export default component.exports